/* eslint-disable quote-props */
import { Box, Button, Typography } from "@mui/material";
import React, { useCallback } from "react";
import { IMappedOrderItem } from "../../../../../../../services/orders/orders.interface";
import { CartIcon, VisibilityOnIcon } from "../../../../../../../components/Icons";
import { useVetCoveRedirect } from "../../../../../../../hooks/useVetCoveRedirect";

interface IOrderItemProps {
  item: IMappedOrderItem;
  showBuyAgain: boolean;
}

const OrderItem = ({ item, showBuyAgain }: IOrderItemProps) => {
  const { productUrl, quantity, price, name, petName } = item;
  const { handleVetCoveLink } = useVetCoveRedirect();

  const handleClick = useCallback(() => {
    handleVetCoveLink(productUrl);
  }, [productUrl, handleVetCoveLink]);

  return (
    <Box
      className="flex justify-between gap-4 rounded-[10px] p-3"
      sx={{
        backgroundColor: "neutral.lighter",
        flexDirection: { xs: "column", sm: "row" },
        alignItems: { xs: "flex-end", sm: "center" },
      }}
    >
      <Box className="flex justify-between w-full">
        <Box>
          <Typography fontSize={16}>{name}</Typography>
          <Typography>For {petName}</Typography>
        </Box>
        <Box className="flex justify-between gap-4">
          <Box className="text-right min-w-[80px]">
            <Typography>Qty: {quantity}</Typography>
            <Typography fontSize={16}>${price}</Typography>
          </Box>
        </Box>
      </Box>
      <Button
        variant="outlined"
        size="small"
        startIcon={showBuyAgain ? <CartIcon width={20} height={20} /> : <VisibilityOnIcon width={20} height={20} />}
        onClick={handleClick}
        sx={{
          backgroundColor: "white.main",
          borderColor: "neutral.main",
          borderRadius: "8px",
          color: "black.main",
          whiteSpace: "nowrap",
          fontSize: "12px",
          "&:hover": {
            borderColor: "black.main",
            backgroundColor: "white.main",
          },
        }}
      >
        {showBuyAgain ? "Buy Again" : "View Product"}
      </Button>
    </Box>
  );
};

export default OrderItem;
